import { Observable } from 'rxjs'
import intl from 'react-intl-universal'
import { getSettings } from '../settingsReducer'
import { errorAction } from '~/redux/commonActions'

const ACTION_PREVIEW = 'ellipsis.actions.preview'

function getStoryPropVal(key, story) {
  const parts = key.replace(/^:/, '').replace(/[{}]/g, '').split(/\./g)
  return parts.reduce((p, k) => {
    if (p !== undefined && typeof p[k] !== 'undefined') {
      return p[k]
    } else {
      return undefined
    }
  }, story)
}

const storyPreviewEpic = (action$, store, { serviceResolver }) =>
  action$
    .ofType(ACTION_PREVIEW)
    .map(() => getSettings(store.getState()))
    .mergeMap((settings) => {
      const storyService = serviceResolver('storyService')
      return Observable.from(storyService.getStory()).map((story) => {
        if (!story) {
          return new Error(intl.get('epics.storyPreviewEpic.errors.noStory'))
        }

        let { pageBuilderPrvURL: url = '', pageBuilderPrvDomain } = settings

        if (!url || url.length === 0) {
          return new Error(
            intl.get('epics.storyPreviewEpic.errors.noPreviewUrl')
          )
        }

        let regExp = /:[^/:]*/g
        if (url.indexOf('{') > -1) {
          regExp = /\{[^{]*\}/g
        }

        const params = url.match(regExp)
        if (params) {
          params.forEach((key) => {
            const replacement = getStoryPropVal(key, story)
            if (replacement) {
              url = url.replace(key, replacement)
            }
          })
        }

        let urlObj
        try {
          urlObj = new URL(url, window.location.origin)
        } catch (error) {
          // preview URL is configured, though possibly invalid
          return new Error(
            intl.get('epics.storyPreviewEpic.errors.invalidPreviewUrl', {
              url: `${window.location.origin}${url}`,
            })
          )
        }

        if (pageBuilderPrvDomain) {
          urlObj.searchParams.append('pbdomain', pageBuilderPrvDomain)
        }

        window.open(urlObj.toJSON(), '_blank')
      })
    })
    .filter((action) => action instanceof Error)
    .map((error) => errorAction(error))

export default storyPreviewEpic
